import { Component, Input, EventEmitter, Output } from '@angular/core';

import { Person } from 'app/fs/res/common/model/person/person';

@Component( {
    selector: 'res-external-person-create',
    templateUrl: './external-person-create.component.html'
} )

export class ExternalPersonCreateComponent {
    @Input() externalPerson: Person;
    @Output() externalPersonChange: EventEmitter<Person> = new EventEmitter();
}
